const loginReducerInitialState = {
    isSinged: false,
    loginFalse: false,
    email: '',
    password: '',
    token: '',
    isLoading: true,
    redirectLogin: true,
    notifications: {},
    unread_notification: 0,
    is2Fa: false,
    isupdateInfo: false,
}

const loginReducer = (state = loginReducerInitialState, action) => {
    switch (action.type) {
        case 'login':
            return { ...state, isSinged: true, token: action.item.token, is2Fa: action.item.is2Fa };
        case 'update2Fa':
            return { ...state, isSinged: true, is2Fa: action.item.is2Fa };
        case 'updateInfo':
            return { ...state, isSinged: true, isupdateInfo: true };
        case 'remember':
            return { ...state, email: action.item.email, password: action.item.password };
        // return { ...state, isSinged: false, isLoading: false }
        case 'logOut':
            // console.log("da goi den", state, action)
            return { ...state, isSinged: false , loginFalse: false, token: '', user: {},
                redirectLogin: true, notifications: {}, unread_notification: 0, isupdateInfo: false };
        case 'changeRedirectLogin':
            return { ...state, redirectLogin: false };
        case 'checkLogin':
            return state;
        default:
            return state;
    }
}

export default loginReducer;